'use client';

import { useEffect, useRef } from 'react';
import { Container, useAutoPlayVideoRef } from '../shared';
import { useGsapContext } from 'hooks/animation/useGsapContext';
import { useIsomorphicLayoutEffect } from 'hooks/dom/useIsomorphicLayoutEffect';
import gsap from 'gsap';
import { getCompressedAssetUrl } from 'lib/config/assetUrls';
import { FlatLink } from '..';
import { RightArrow } from 'assets/icons';
import styles from './RarebenefitsBannerSection.module.css';

const mobileVideoPath = getCompressedAssetUrl(
  '/web_v2/rare/videos/gold-pellets-ring.mp4/w_1920',
);
const desktopVideoPath = getCompressedAssetUrl(
  '/web_v2/rare/videos/hero-rare-1920-2.mp4/w_1920',
);

export const RarebenefitsBannerSection = () => {
  const videoRef = useAutoPlayVideoRef();
  const headingRef = useRef<HTMLHeadingElement>(null);
  const linkRef = useRef<HTMLAnchorElement>(null);
  const gsapContext = useGsapContext();

  useEffect(() => {
    const setDesktopVideoIfLargeScreen = () => {
      if (!videoRef.current) {
        return;
      }
      if (
        window.innerWidth > window.innerHeight &&
        (!videoRef.current.src ||
          !videoRef.current.src.endsWith(desktopVideoPath))
      ) {
        videoRef.current.src = desktopVideoPath;
        return;
      }
      if (
        window.innerWidth < window.innerHeight &&
        (!videoRef.current.src ||
          !videoRef.current.src.endsWith(mobileVideoPath))
      ) {
        videoRef.current.src = mobileVideoPath;
        return;
      }
    };

    window.addEventListener('resize', setDesktopVideoIfLargeScreen);
    setDesktopVideoIfLargeScreen();

    return () => {
      window.removeEventListener('resize', setDesktopVideoIfLargeScreen);
    };
  }, []);

  useIsomorphicLayoutEffect(() => {
    if (!headingRef.current) {
      return;
    }

    gsapContext.add(() => {
      if (!headingRef.current) {
        return;
      }

      const tl = gsap.timeline({
        defaults: {
          duration: 1,
          ease: 'power2.out',
        },
      });

      tl.fromTo(
        headingRef.current?.querySelectorAll('.hero-letters'),
        {
          opacity: 0,
          yPercent: 100,
        },
        {
          opacity: 1,
          yPercent: 0,
          stagger: 0.04,
        },
      );

      tl.fromTo(
        linkRef.current,
        {
          opacity: 0,
          yPercent: 100,
        },
        {
          opacity: 1,
          yPercent: 0,
          duration: 0.2,
        },
      );
    });

    //--- --- -- end
  }, []);

  return (
    <section className={styles.root}>
      {}
      <video preload="none" loop autoPlay muted playsInline ref={videoRef}>
        <source src={mobileVideoPath} type="video/mp4" />
      </video>

      <Container className={styles.container}>
        <div className={styles.content}>
          <h1 ref={headingRef}>
            <span className={styles.sentence}>EXCLUSIVE BENEFITS FOR</span>
            <span className={styles.sentence}>ULTRAHUMAN RING RARE</span>
          </h1>
          <div className={styles['cta-container']}>
            <FlatLink
              style={{ color: '#ffffff' }}
              href={{
                pathname: '/rare',
                hash: 'rare-uhx-benefits',
              }}
            >
              Checkout exclusive Rare Ring UHX benefits <RightArrow />
            </FlatLink>
          </div>
        </div>
      </Container>
    </section>
  );
};
